import { render, staticRenderFns } from "./SiteBanner.vue?vue&type=template&id=1009d882&scoped=true"
import script from "./SiteBanner.vue?vue&type=script&lang=ts"
export * from "./SiteBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1009d882",
  null
  
)

export default component.exports